import type { DashboardComponent } from '../services/dashboard.service';

interface LinkedObject {
  name?: string;
  description?: string;
}

export function resolveComponentTitle(
  component: Pick<DashboardComponent, 'title' | 'object_type'>,
  linkedObject?: LinkedObject | null,
): string {
  if (component.title) return component.title;
  if (component.object_type === 'ANALYSIS' && linkedObject?.name) return linkedObject.name;
  if (component.object_type === 'FILTER' && linkedObject?.name) return `Filter ${linkedObject.name}`;
  return 'Untitled';
}

export function resolveComponentDescription(
  component: Pick<DashboardComponent, 'description' | 'object_type'>,
  linkedObject?: LinkedObject | null,
): string | undefined {
  if (component.description) return component.description;
  if (component.object_type === 'ANALYSIS' && linkedObject?.description) return linkedObject.description;
  if (component.object_type === 'FILTER' && linkedObject?.description) return linkedObject.description;
  return undefined;
}
